import React from "react";
import { ColorOverride, HeadingTypes } from "../../../styles/fonts";
import { Heading, HeadingProps, HeadingTag, HeadingWeightOverride } from "../../Heading/Heading";

export interface FeatureHeadingProps {
    /**
     * DOM structure heading tag "h1", "h2", "h3", "h4", "h5", or "h6"
     */
    readonly tag?: HeadingTag;

    /**
     * Visual font ramp variant
     */
    readonly variant?: HeadingTypes;

    /**
     * Display text
     */
    readonly text: string;

    /**
     * Feature header theme.
     */
    readonly headerColorOverride?: ColorOverride;

    /**
     * Optional override of the font-weight defined in the type ramp. Only
     * accepts "bold" currently as all Heading types already have `semi-bold`
     * font weight
     */
    readonly weightOverride?: HeadingWeightOverride;
}

export const FeatureHeading: React.FC<FeatureHeadingProps> = ({
    tag,
    variant,
    text,
    headerColorOverride,
    weightOverride
}) => {
    const headingProps: HeadingProps = {
        tag: tag ?? "h5",
        variant: variant ?? "statusHeader",
        children: text
    };

    return (
        <Heading
            {...headingProps}
            colorOverride={headerColorOverride}
            weightOverride={weightOverride}
        />
    );
};
